import { Link, Navigate } from 'react-router-dom';
import { ArrowLeft, CalendarDays } from 'lucide-react';
import GameCalendar from '../components/GameCalendar';

// Every NBA / NFL / college football game, month by month; tap a day for its games.
export default function SchedulePage() {
  if (sessionStorage.getItem('sports_betting_authed') !== 'true') return <Navigate to="/sports-betting" replace />;
  return (
    <div className="min-h-screen bg-zinc-950 p-4 text-white md:p-6" data-testid="schedule-page">
      <div className="mx-auto max-w-3xl space-y-4">
        <div className="flex items-center justify-between gap-3">
          <Link to="/sports-betting" className="flex items-center gap-1 text-sm text-zinc-400 hover:text-white" data-testid="schedule-back"><ArrowLeft className="h-4 w-4" /> My tickets</Link>
          <h1 className="flex items-center gap-2 text-lg font-bold md:text-xl"><CalendarDays className="h-5 w-5 text-amber-400" />Schedule</h1>
        </div>
        <GameCalendar />
      </div>
    </div>
  );
}
